// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { HistoryFeedInfoFragmentDoc } from '../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChangeEventHistoryQueryVariables = Types.Exact<{
  changeEventId: Types.Scalars['ID']['input'];
}>;


export type ChangeEventHistoryQuery = { __typename?: 'Query', changeEvents: Array<{ __typename?: 'ChangeEvent', id: string, history: Array<{ __typename?: 'History', avatar: string, title: string, subtitle?: string | null | undefined, recordedAt: Types.Scalars['DateTime']['input'], userName?: string | null | undefined }> }> };


export const ChangeEventHistoryDocument = gql`
    query ChangeEventHistory($changeEventId: ID!) {
  changeEvents(filter: {id: [$changeEventId]}) {
    id
    history {
      ...HistoryFeedInfo
    }
  }
}
    ${HistoryFeedInfoFragmentDoc}`;

/**
 * __useChangeEventHistoryQuery__
 *
 * To run a query within a React component, call `useChangeEventHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeEventHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeEventHistoryQuery({
 *   variables: {
 *      changeEventId: // value for 'changeEventId'
 *   },
 * });
 */
export function useChangeEventHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChangeEventHistoryQuery, ChangeEventHistoryQueryVariables> & ({ variables: ChangeEventHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChangeEventHistoryQuery, ChangeEventHistoryQueryVariables>(ChangeEventHistoryDocument, options);
      }
export function useChangeEventHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChangeEventHistoryQuery, ChangeEventHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChangeEventHistoryQuery, ChangeEventHistoryQueryVariables>(ChangeEventHistoryDocument, options);
        }
export function useChangeEventHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeEventHistoryQuery, ChangeEventHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChangeEventHistoryQuery, ChangeEventHistoryQueryVariables>(ChangeEventHistoryDocument, options);
        }
export type ChangeEventHistoryQueryHookResult = ReturnType<typeof useChangeEventHistoryQuery>;
export type ChangeEventHistoryLazyQueryHookResult = ReturnType<typeof useChangeEventHistoryLazyQuery>;
export type ChangeEventHistorySuspenseQueryHookResult = ReturnType<typeof useChangeEventHistorySuspenseQuery>;
export type ChangeEventHistoryQueryResult = Apollo.QueryResult<ChangeEventHistoryQuery, ChangeEventHistoryQueryVariables>;